/**
 * PresetPage — renders the correct page variant for a given route slot.
 *
 * Usage:
 *   <Route path="/home" element={<PresetPage slot="home" fallback={<HomePage />} />} />
 *
 * Resolution order per slot:
 *   1. variant id from the effective preset's page_config[slot].variant
 *   2. `${slot}_v1` (hardcoded fallback inside the VARIANTS registry)
 *   3. `fallback` prop
 *   4. null (renders nothing) — PresetShell will still render the frame.
 */
import { usePreset } from "../context/PresetProvider";
import { resolveVariant } from "../registry";

export default function PresetPage({ slot, fallback = null, ...rest }) {
    const { preset } = usePreset();
    const variantId = preset?.page_config?.[slot]?.variant;
    const Component = resolveVariant(slot, variantId);

    if (!Component) return fallback;
    return <Component slot={slot} preset={preset} {...rest} />;
}
